import './header.css';
import { IListing } from "../../models/listing.model";
import { ListingShareButtons } from './listing-share-buttons';
import { MutableRefObject, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IBranding } from '../../models/branding.model';
import { isNullOrUndefinedOrBlank } from '../../util/isNullOrUndefinedOrBlank';
import { iconBookmark, iconBookmarkSolid, iconShare, iconClose } from '../../util/icons';

export interface HeaderProps {
  listing: IListing | null;
  isSaved: boolean;
  closeUrl: MutableRefObject<string>;
  branding: IBranding;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
}

export const Header = (props: HeaderProps) => {

  const [isShareOpen, setIsShareOpen] = useState(false);
  const navigate = useNavigate();

  const closeListing = () => {
    navigate(props.closeUrl.current);
  };

  const favButton = useMemo(() =>
    props.listing === null ? <div></div> : <button onClick={() => props.isSaved ? props.removeSavedListing(props.listing) : props.addSavedListing(props.listing)}>{props.isSaved ? iconBookmarkSolid : iconBookmark} {props.isSaved ? 'Saved' : 'Save'} </button>
    , [props]);

  const shareButton = useMemo(() =>
    props.listing !== null && <button onClick={() => setIsShareOpen(!isShareOpen)}>{iconShare} Share</button>
    , [isShareOpen, setIsShareOpen, props.listing]);

  const shareButtonOptions = useMemo(() =>
    isShareOpen
      ? <ListingShareButtons close={() => setIsShareOpen(false)} />
      : <div />
    , [isShareOpen, setIsShareOpen]);

  return (
    <div className="header">
      <div className="header-inner">
        <div className="header-logo">
          {!isNullOrUndefinedOrBlank(props.branding.brokerage_logo_url) &&
            <img loading="lazy" src={props.branding.brokerage_logo_url} alt={props.branding.brokerage_name} />
          }
        </div>
        <div className="first-action">
          {favButton}
        </div>
        <div>
          {shareButton}
          {shareButtonOptions}
        </div>
        {props.closeUrl !== undefined &&
          <div>
            <button className="close-button" onClick={() => closeListing()}>{iconClose} Close</button>
          </div>
        }
      </div>
    </div>
  );
}
